var colors = {
  black: '#000000',
  black80: '#333333',
  black60: '#666666',
  black40: '#999999',
  black20: '#cccccc',
  black15: '#d9d9d9',
  black13: '#dddddd',
  black5: '#f2f2f2',
  black3: '#fbfbfb',
  blue2: '#2fa7e4',
  blueFooterLinks: '#9fddff',
  blueGray: '#889fac',
  blueGray2: '#64747d',
  changeNotification: '#ffffda',
  contrastBlue: '#085397',
  darkBlue: '#001731',
  errorBg: '#fedfe1',
  errorRed: '#e21408',
  extraBlue: '#cae4f2',
  extraGreen: '#8cc36f',
  green5: '#b5d563',
  notification: '#f2633a',
  ochre: '#907103',
  olive: '#657b24',
  orange4: '#fdc600',
  orange3: '#ffaf00',
  orange2: '#ff9600',
  pricelineBlue: '#0a84c1',
  primaryGreen: '#3c910e',
  saleRed: '#b01408',
  secondaryBlue: '#60afd7',
  secondaryGreen: '#47a216',
  successBg: '#ebfae4',
  warningOrNotice: '#ffe96e',
  white: '#ffffff'
};

export default colors;